import axiosClient from '../../../config/axios-client'

const SponsorService = {
  getSponsorsLogos() {
    return axiosClient.get(`/platform/sponsors/logos`)
  },
  getSponsorTypes() {
    return axiosClient.get(`/platform/sponsors`)
  },
  getPackages() {
    return axiosClient.get(`/platform/sponsors/packages`)
  },
  getSponsor(sponsorSlug) {
    return axiosClient.get(`/platform/sponsors/${sponsorSlug}`)
  },
  createSponsorRequest(payload) {
    return axiosClient.post(`/platform/sponsors/requests`, payload)
  },
}

export default SponsorService
